import { render, staticRenderFns } from "./BusinessInfoCard.vue?vue&type=template&id=ba9a8a58&scoped=true"
import script from "./BusinessInfoCard.vue?vue&type=script&lang=js"
export * from "./BusinessInfoCard.vue?vue&type=script&lang=js"
import style0 from "./BusinessInfoCard.vue?vue&type=style&index=0&id=ba9a8a58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9a8a58",
  null
  
)

export default component.exports